import React from "react";
import { Card, Button } from "react-bootstrap";
import Scrollbars from "react-custom-scrollbars-2";
import { formatDate } from "../utils/dateUtils";

export const PrescriptionSummary = ({
	t,
	selectedPatient,
	recentPrescriptions,
	onClose,
	onSelectPrescription,
	isHospitalConnected,
	customerType,
	addedPrescriptions,
}) => {

	return (
		<Card className="mb-3 prescriptions-card">
			<Card.Header
				style={{ position: "relative", padding: "10px 15px", display: "flex", justifyContent: "space-between", alignItems: "center" }}
			>
				<h6 style={{ margin: 0, fontWeight: 600 }}>
					{isHospitalConnected && customerType === "hospital_patient"
						? `${t("Top 5 Recent Prescriptions for")} ${selectedPatient?.full_name}`
						: `${t("Last 5 Sales for")} ${selectedPatient?.patient_name || selectedPatient?.full_name
						}`}
				</h6>

				<Button
					variant="link"
					className="p-0 prescriptions-card-close"
					onClick={onClose}
					aria-label={t("Close prescriptions card")}
				>
					&times;
				</Button>
			</Card.Header>
			<Card.Body>
				<Scrollbars
					autoHide
					style={{ height: `150px` }}
					universal
					renderTrackHorizontal={(props) => <div {...props} style={{ display: "none" }} />}
				>
					{recentPrescriptions.map((prescription, index) => {
						const rawItems = prescription?.prescriptions || prescription?.items || [];
						const itemCount = rawItems?.length || 0;
						const isInCart = addedPrescriptions?.has(prescription._id);
						const medsList =
							rawItems?.slice(0, 2).map((item) => {
								const name =
									item.medication_name ||
									item.medicineName ||
									item.brandName ||
									item.name ||
									item.productName ||
									t("Unknown Medicine");
								const salt = item.salt_composition || "";
								return `${name}${salt ? ` ${salt}` : ""}`;
							}) || [];

						return (
							<div
								key={prescription._id}
								className={`border-bottom prescription-item${isInCart ? " prescription-item--active" : ""}`}
								onClick={() => onSelectPrescription(prescription)}
								style={{ cursor: "pointer" }}
							>
								<strong>
									{t("Date")}: {formatDate(prescription?.createdAt)}
									{isInCart && (
										<span className="prescription-in-cart-badge ms-2">
											{t("In Cart")}
										</span>
									)}
								</strong>
								<p className="mb-0 mt-1 ms-2 prescription-item-meta small">
									{isHospitalConnected && customerType === "hospital_patient"
										? `${t("Consulted by")}: ${prescription?.doctor?.name || "N/A"}`
										: `${t("Items")}: ${itemCount}`}
								</p>
								{isHospitalConnected && customerType === "inpatient" &&
									medsList.map((med, i) => (
										<li className="tw-text-dark" key={i} style={{ lineHeight: "1.2em" }}>
											{med}
											{i === medsList.length - 1 && itemCount > 2 && (
												<span className="text-muted small">
													+ {itemCount - 2} more
												</span>
											)}
										</li>
									))
								}
							</div>
						)
					}
					)}
				</Scrollbars>
			</Card.Body>
		</Card>
	);
};

export default PrescriptionSummary;

